import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import currencies from '../../../currencies';
import CurrencySelectListItem from './CurrencySelectListItem';

const CurrencySelectList = ({ searchString, selectedCurrency, onClick }) => {
  const chars = { Ä: 'A', Đ: 'D' };
  const favorites = ['EUR', 'USD', 'AUD', 'GBP', 'CNY', 'RUB'];
  let newSection = null;
  let actualSection = null;

  const filteredCurrencies = currencies
    .filter((currency) => {
      const currencySearchString = `${currency.value} ${currency.label} ${currency.countries}`;
      return currencySearchString.toLowerCase().includes(searchString);
    });

  const favoritCurrencies = currencies
    .filter(currency => favorites.includes(currency.id));


  return (
    <List>
      {!searchString && (
        <Grid container spacing={8}>
          <Grid item xs={12} style={{ background: 'rgba(0,0,0,0.1)', margin: '1rem 0.25rem', padding: '0.5rem 1rem' }}>Favoriten</Grid>
          {favoritCurrencies.map(
          currency => (
            <Grid key={currency.id} item xs={12} sm={6} lg={4} style={{ padding: '0 5px' }}>
              <CurrencySelectListItem
                onClick={() => onClick(currency)}
                currency={currency}
                selected={currency.value === selectedCurrency}
              />
            </Grid>
          ),
        )}
        </Grid>
      )}

      {filteredCurrencies.map(
          (section) => {
             actualSection = section.label.charAt(0).replace(/[Ä|Đ]/g, m => chars[m]);

             if (newSection !== actualSection) {
               newSection = actualSection;

               return (
                 <Grid container spacing={8} key={actualSection}>
                   <Grid item xs={12} style={{ background: 'rgba(0,0,0,0.1)', margin: '1rem 0.25rem', padding: '0.5rem 1rem' }}>{actualSection}</Grid>
                   {filteredCurrencies.filter(s => s.label[0] === actualSection).map(
                     currency => (
                       <Grid key={currency.id} item xs={12} sm={6} lg={4} style={{ padding: '0 5px' }}>
                         <CurrencySelectListItem
                           onClick={() => onClick(currency)}
                           currency={currency}
                           selected={currency.value === selectedCurrency}
                         />
                       </Grid>
                     ),
                   )}
                 </Grid>
               );
             }
               return '';
          },
        )
      }

    </List>
  );
};

CurrencySelectList.propTypes = {
  searchString: PropTypes.string.isRequired,
  selectedCurrency: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default CurrencySelectList;



// WEBPACK FOOTER //
// ./src/components/calculator/currency-select/CurrencySelectList.js